import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { type KnownUnit, unitImage, unitName, unknownUnit } from '../unit/unit'
import { findById } from '../../../shared/lib/functional/identifiable.no-deps'
import type { WithCachedImageUrl } from '../image/WithCachedImage'
import { type PromiseState, promiseStateRender } from '../util/PromiseState'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'
import { assert } from 'tsafe'
import { last } from '../../../shared/lib/functional/array.no-deps'
import classNames from 'classnames'

interface Props {
    deps: CommonDeps
    allUnitsState: PromiseState<KnownUnit[]>
    withCachedImageUrl: WithCachedImageUrl
    loopPathIds: LoopPathIds
    size?: 'small'
}

export function LoopSubject(props: Props) {
    if (props.loopPathIds.length === 0) return null

    return promiseStateRender(props.deps, props.allUnitsState, (allUnits) => {
        const loopId = last(props.loopPathIds)
        assert(loopId.unitId !== null)

        const unit = findById(allUnits, loopId.unitId) ?? unknownUnit(loopId.unitId)
        const imageUrl = unitImage(unit)

        return props.withCachedImageUrl(imageUrl, (cachedImageUrl) => (
            <div
                className={classNames('AppCore__flow__LoopSubject', {
                    'AppCore__flow__LoopSubject--small': props.size === 'small',
                })}
            >
                <img
                    className="AppCore__flow__LoopSubject__image"
                    src={imageUrl ? cachedImageUrl : props.deps.getImage('missing-unit')}
                />
                <div className="AppCore__flow__LoopSubject__text">{unitName(unit)}</div>
            </div>
        ))
    })
}
